import { CollapseProps } from 'antd';
import { FormikProps } from 'formik';

import { MFilter } from '@Components/Base';
import { useAppSelector } from '@Hooks/index';
import { MultiSelect } from '@Components/Filters';

import {
  getMrForDict,
  getPurchaseClassifications,
  getRFQStatusDict,
  getTenderExtensionTypeDict,
  getTenderForDict,
} from '@Store/selectors/dictionarySelector';
import { FilterForm } from './types';
import { mockTenderAmount } from './filters.utils';

interface FiltersProps {
  formik: FormikProps<FilterForm>;
  showError?: boolean;
}

const Filters: React.FC<FiltersProps> = ({ formik, showError = false }) => {
  const mrForTypes = useAppSelector(getMrForDict);
  const tenderForTypes = useAppSelector(getTenderForDict);
  const classificationsType = useAppSelector(getPurchaseClassifications);
  const tenderExtensionType = useAppSelector(getTenderExtensionTypeDict);
  const rfqStatus = useAppSelector(getRFQStatusDict);

  const items: CollapseProps['items'] = [
    {
      id: 'AMOUNT',
      label: 'Tender Amount',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="tenderAmount"
          options={Object.keys(mockTenderAmount)}
        />
      ),
    },
    {
      id: 'PRFOR',
      label: 'PR For',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="prFor"
          options={mrForTypes.map((type) => type.codeDesc)}
        />
      ),
    },
    {
      id: 'TENDERFOR',
      label: 'Tender For',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="tenderFor"
          options={tenderForTypes.map((type) => type.codeDesc)}
        />
      ),
    },
    {
      id: 'PRIORITY',
      label: 'Priority',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="priority"
          options={['Normal', 'Emergency']}
        />
      ),
    },
    {
      id: 'CLASSIFICATION',
      label: 'Classification',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="classification"
          options={classificationsType.map((type) => type.codeDesc)}
        />
      ),
    },
    {
      id: 'EXTENTIONTYPE',
      label: 'Tender Extention Type',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="tenderExtensionType"
          options={tenderExtensionType.map((type) => type.codeDesc)}
        />
      ),
    },
    {
      id: 'STATUS',
      label: 'Status',
      children: (
        <MultiSelect<FilterForm>
          formik={formik}
          formikKey="tenderStatus"
          options={rfqStatus.map((status) => status.codeDesc)}
          showSearch
        />
      ),
    },
  ];

  return (
    <MFilter<FilterForm> showError={showError} formik={formik} items={items} />
  );
};

export default Filters;
